module.exports = __webpack_public_path__ + "static/media/Moj-3.0ce64789.PNG";